import api from './axiosInstance';

export async function getLawyerScoringRanking(areaId, startDate, endDate) {
  try {
    const params = {
      areaId: areaId > 0 ? areaId : null,
      startDate,
      endDate,
    };

    const response = await api.get(`/lawyer-scoring/ranking`, {
      headers: {
        'Content-Type': 'application/json',
      },
      params,
    });

    return response.data;
  } catch (error) {
    error.customMessage = 'No se pudo obtener el ranking.';
    throw error;
  }
}
